import { mergeStyleSets, mergeStyles } from "@fluentui/merge-styles";
import { displayClassNames, makeStyles, tokens } from "@fluentui/react-components";
import { FONT_SIZE_LARGE, FONT_SIZE_SMALL } from "../../../config/fontSizes";


export const modalStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    minHeight: "145px",
    maxWidth: "90%",
    width: "90%",
    padding: "24px",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  header: [
    {
      fontSize: "17px",
      fontWeight: "300",
    },
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${tokens.colorBrandForeground1}`,
      color: tokens.colorNeutralForeground1,
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      padding: "12px 12px 14px 24px",
    },
  ],
  heading: {
    color: tokens.colorNeutralForeground1,
    fontWeight: 600,
    fontSize: FONT_SIZE_LARGE,
    margin: "0",
  },
  body: {
    display: "flex",
    justifyContent: "space-around",
    padding: "12px",
    gridColumn: "1 / -1",
  },
  btnClass: {
    width: "100%",
    margin: "0 10px",
  },
});

export const pickerStyle = mergeStyles({
  marginBottom: 30,
});

export const saveBtnClass = mergeStyles({
  width: "100%",
  marginBottom: 15,
});
export const iconButtonClass = mergeStyles({
  color: tokens.colorNeutralForeground1,
  marginLeft: "auto",
  marginTop: "2px",
  marginRight: "2px",
});



export const useDialogTitleStyles = makeStyles({
  title: {
    fontSize: tokens.fontSizeBase400,
    margin: "0",
    minWidth: 0,
    overflowWrap: "anywhere",
    paddingRight: tokens.spacingHorizontalS,
  },
});


export const tagPickerWrapperClass = mergeStyles({
  width: "100%",
});
export const progressBarWrapperClass = mergeStyles({
  marginBottom: 15,
  height: 4,
});

export const progressBarClass = mergeStyles({
  height: "100%",
});

export const infoBarClass = mergeStyles({
  marginTop: 12,
  "& .fui-MessageBarBody": {
    fontSize: FONT_SIZE_SMALL,
  },
});

export const scrollContainerClass = mergeStyles({
  height: "calc(100vh - 60px)",
  overflowY: "auto",
  padding: "0 10px 20px",
  boxSizing: "border-box",
});

export const optionSecondaryTextClass = mergeStyles({
  display: "block",
  fontSize: "11px",
  color: tokens.colorNeutralForeground3,
});

export const selectedListClass = mergeStyles({
  listStyleType: "none",
  margin: "8px 0 0 0",
  padding: 0,
});

export const selectedItemRowClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "6px 8px",
  borderRadius: "4px",
  backgroundColor: tokens.colorNeutralBackground3,
  marginBottom: "6px",
});

export const selectedItemTextBlockClass = mergeStyles({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
});

export const selectedItemNameClass = mergeStyles({
  fontSize: "13px",
  fontWeight: 600,
  color: tokens.colorNeutralForeground1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const selectedItemSecondaryClass = mergeStyles({
  fontSize: "11px",
  color: tokens.colorNeutralForeground3,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const selectedItemRemoveBtnClass = mergeStyles({
  flexShrink: 0,
  minWidth: "unset",
  padding: "2px",
  color: tokens.colorNeutralForeground3,
  selectors: {
    ":hover": { color: tokens.colorNeutralForeground1 },
  },
});
